<div class="list-group">
  @for (ref of page; track ref; let idx = $index) {
    @if (evidenceMap.get(ref.citation); as evidence) {
      <label
        class="list-group-item d-flex flex-column gap-1"
        [for]="'fact-' + idx">
        <div class="d-flex gap-2">
          @if (isSelectable) {
            <input
              class="form-check-input"
              type="checkbox"
              [attr.id]="'fact-' + idx"
              [formControl]="factControlCitationMap.get(ref.instruction)" />
          }
          <h5>
            {{ ref.citation }}.
            @if (evidence.url) {
              Source:
              <a [href]="evidence.url" target="_blank">
                {{ evidence.url | shortDomain }}
              </a>
            } @else {
              Source {{ ref.citation }}
            }
          </h5>
        </div>
        <p class="m-0">
          <strong>Suggestion:</strong>
          {{ ref.instruction }}
        </p>
        <p class="m-0">
          <strong>Original fact:</strong>
          @if (evidence.url) {
            {{ ref.original_fact | slice: 0 : 90
            }}{{ ref.original_fact.length > 90 ? '&hellip;' : '' }}
          } @else {
            {{ ref.original_fact }}
          }
        </p>
      </label>
    } @else {
      <div class="list-group-item d-flex flex-column gap-1">
        <p class="m-0">
          <strong>Suggestion:</strong>
          {{ ref.instruction }}
        </p>
        <p class="m-0">
          <strong>Original fact:</strong>
          {{ ref.original_fact }}
        </p>
      </div>
    }
  }
</div>

@if (facts.length > pageSize) {
  <p-paginator
    [first]="pageIndex"
    [rows]="pageSize"
    [pageLinkSize]="pageLinkSize"
    [totalRecords]="facts.length"
    [showPageLinks]="true"
    [showFirstLastIcon]="false"
    (onPageChange)="onPageChange($event)" />
}
